var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('product-checkout',{attrs:{"price":_vm.product ? _vm.product.price : null,"name":_vm.product ? _vm.product.display_name : null,"show-button":true},on:{"submitted":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }